import gql from 'graphql-tag';

export const RECURRING_TIP_FRAGMENT = gql`
  fragment RecurringTipFragment on SubscriptionType {
    id
    created
    amount
    currency
    eligibleForPrivateContent
    privateFeedUrl
    receivesUpdates
    podcast {
      slug
      name
      coverArtThumbnail(size: 80)
      feedbackActive
      hasPrivateEpisodes
      tipJarAccountId
      tipJarSuccessMessage
    }
    lastEvent {
      id
      occurredAt
    }
  }
`;

export const RECURRING_DONATION = gql`
  query RecurringDonation($slug: ID!) {
    tipJarSubscription(podcastSlug: $slug) {
      ...RecurringTipFragment
    }
  }
  ${RECURRING_TIP_FRAGMENT}
`;
export const RECURRING_DONATION_SUPPLEMENTAL = gql`
  query RecurringDonationSupplemental($slug: ID!) {
    tipJarSubscription(podcastSlug: $slug) {
      id
      nextInvoiceDate
      events {
        id
        amount
        currency
        occurredAt
        podcast {
          slug
          name
        }
      }
      paymentCard {
        last4
        expMonth
        expYear
        brand
      }
      willCancel
    }
  }
`;
